export const variables = {
	invoiceDueDate: '%payment_due_date%',
	invoiceAmount: '%payment_amount%',
	companyName: '%business_name%',
	companyPhone: '%company_phone%',
	companyEmail: '%company_email%',
	companyAddress: '%business_address%',
	clientName: '%client_name%',
	clientSurname: '%client_surname%',
	clientPhone: '%client_phone%',
	clientAddress: '%client_address%',
	clientEmail: '%client_email%',
	clientNotes: '%client_notes%',
	clientCompanyName: '%client_company%',
	secondaryClientFirstName: '%2nd_client_name%',
	secondaryClientLastName: '%2nd_client_surname%',
	jobName: '$jobName$',
	jobDate: '%job_date%',
	jobStartTime: '%job_start_time%',
	jobEndTime: '%job_end_time%',
	jobLocation: '%job_location%',
	jobNotes: '%job_notes%',
	jobType: '%job_type%',
	jobLeadSource: '%job_leadsource%',
	appointmentDate: '%appointment_date%',
	appointmentStartTime: '%appointment_start_time%',
	appointmentEndTime: '%appointment_end_time%',
	appointmentLocation: '%appointment_location%',
	totalInvoiceAmount: '%total_invoiced%',
	upcomingAppointmentDate: '%next_appointment_date%',
	upcomingAppointmentStartTime: '%next_appointment_start_time%',
	upcomingAppointmentEndTime: '%next_appointment_end_time%',
	upcomingAppointmentLocation: '%next_appointment_location%',
	upcomingExtraShootDate: '%next_extrashoot_date%',
	upcomingExtraShootStartTime: '%next_extrashoot_start_time%',
	upcomingExtraShootEndTime: '%next_extrashoot_end_time%',
	upcomingExtraShootLocation: '%next_extrashoot_location%',
	contractLink: `<span><a href=${'%contract_link%'}>Please view and sign your contract online by clicking here</a></span>`,
	invoiceLink: `<span><a href=${'%invoice_link%'}>Please click here to view and pay your invoice online</a></span>`,
	quoteLink: `<span><a href=${'%quote_link%'}>Please view your quote online by clicking here</a></span>`,
	questionnaireLink: `<span><a href=${'%questionnaire_link%'}>Please view the questionnaire online by clicking here</a></span>`,
	galleriesLink: `<span><a href=${'%galleries_link%'}>Please view the galleries online by clicking here</a></span>`
};



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/models/system-variables/variables.ts